import { BaseSearchComponent } from '@/Components/inputs/SearchBar';
import React, { useCallback } from 'react';
import { z } from 'zod';
import { __useFilterState } from '../useFilterState';

const searchSearchSchema = z.object({
  search: z.string().optional(),
});

const searchComponentProps = z.object({
  style: z.record(z.string(), z.any()).optional(),
  disabled: z.boolean().optional(),
});

type SearchFilterProps = z.infer<typeof searchComponentProps>;

const SearchFilter = (props: SearchFilterProps) => {
  const { fastFilters, updateFilter } = __useFilterState(searchSearchSchema);

  const handleSearchChange = useCallback(
    (value: string) => {
      updateFilter({ search: value || undefined });
    },
    [updateFilter]
  );

  return (
    <BaseSearchComponent
      {...props}
      inputProps={{
        value: fastFilters?.search || '',
        onChange: ({ target: { value } }) => {
          handleSearchChange(value);
        },
      }}
    />
  );
};

const SearchFilterMemo = React.memo(SearchFilter);

export const FilterConfig_Search = {
  search: {
    searchSchema: searchSearchSchema,
    component: SearchFilterMemo,
    componentProps: searchComponentProps,
  },
} as const;
